import React from "react";
import API from "../../utils/API";
import MenuForm from "../../Components/MenuForm/MenuForm";
import AdminNav from "../../Components/AdminNav.jsx/AdminNav";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const NewFood = (props) => {
  const navigate = useNavigate()
  const handleFormSubmit = (
    e,
    { title, description, img, rating, category },
    id
  ) => {
    e.preventDefault();

    // API.createResponse({ title, description, img, rating, category }).then(
    //   (response) => {
    //     props.history.push("/admin/menu");
    //   }
    // );
    const newCategory = category.toLowerCase()
    const newUsername = title.toLowerCase()
    const username = newUsername.replace(" ", "")

    const newService = {
      title: title,
      description: description,
      img: img,
      rating: rating,
      category: newCategory,
      username: username
    }

    if (id) {
      axios.post('/service', newService).then((res)=>{
        console.log(res)
        axios.delete(`/services/${id}`).then((res)=>{
          navigate("/admin/menu");
        })
      }).catch((err)=>{
        console.log(err)
      })
    } else {
       axios.post('/service', newService).then((res)=>{
      console.log(res)
      navigate("/admin/menu");
    }).catch((err)=>{
      console.log(err)
    })
    }

   
  };

  return (
    <>
      <AdminNav />
      <div className="container">
        <div className="row adminMenu">
          <div className="row">
            <div className="col s12">
              <h3 className="center-align formHead">Manage Services</h3>
            </div>
          </div>
          <MenuForm
            handleFormSubmit={handleFormSubmit}
            buttonText="Update Services"
          />
        </div>
      </div>
    </>
  );
};

export default NewFood;
